import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import APICaller from '../../library/APICaller';

import { fetch } from '../../redux/actions';
import { api, values } from './configs';

const mapStateToProps = ({ fetch, MemberReducer }) => {
    const popUps = (fetch?.multipleList?.popUps?.results ?? []).sort((a, b) => {
        return moment(a.createdDate).isBefore(b.createdDate);
    });

    const parent = MemberReducer.actor;

    return {
        popUps: popUps.length > 1 ? popUps.slice(0, 1) : popUps,
        parent,
    };
};

const mapDispatchToProps = (dispatch) => ({
    multipleList: (list) => dispatch(fetch.multipleList(list)),
});

class EventPopUp extends Component {
    constructor(props) {
        super(props);

        const show = JSON.parse(localStorage.getItem(`POPUP${values.baseName}`))
            ? moment().isAfter(
                  JSON.parse(localStorage.getItem(`POPUP${values.baseName}`))
              )
            : true;

        this.state = {
            boardType: 'NoticeBoard',
            boardName: '학부모메인',
            visible: show,
            item: {},
        };
    }

    componentDidMount() {
        this.fetchPopUps();
    }

    fetchPopUps = async () => {
        try {
            const { boardType, boardName } = this.state;

            const { url, params } = api.getBoard(boardType, {
                name: boardName,
            });

            const { data } = await APICaller.get(url, params);
            if (!data) throw Error('No data found');

            await this.props.multipleList([
                {
                    id: 'popUps',
                    ...api.getPostList(data.id, {
                        data__event_info__start_date__lte: moment().format(
                            values.format.DATE_FORMAT
                        ),
                        data__event_info__end_date__gte: moment().format(
                            values.format.DATE_FORMAT
                        ),
                        isShowPc: true,
                    }),
                },
            ]);

            const { popUps } = this.props;
            if (popUps.length) {
                this.setState({ item: popUps[0] });
            }
        } catch (error) {
            console.error(error);
        }
    };

    setStorage(value) {
        this.setState({
            visible: false,
        });
        const endTime = moment()
            .endOf('day')
            .add(Number(value), 'd')
            .format(values.format.FULL_DATETIME_FORMAT);
        return localStorage.setItem(
            `POPUP${values.baseName}`,
            JSON.stringify(endTime)
        );
    }

    checkDisplayActorStatus() {
        const { parent } = this.props;
        const { item } = this.state;
        const displayActorType = item?.data?.eventInfo?.displayActorType ?? [];
        if (displayActorType[0] === '0') return true;
        const parentStatus = parent.status;
        if (parentStatus === 10) {
            return displayActorType.find((actorType) => actorType === '100');
        }
        return (
            parentStatus &&
            displayActorType.find(
                (actorType) => actorType === parentStatus.toString()
            )
        );
    }

    renderCheckBox() {
        const { item } = this.state;
        const displayNoneCycle = item?.data?.eventInfo?.displayNoneCycle ?? '';
        return (
            <div className="checkbox-area">
                <div onClick={this.onClickDisplayNoneCycle.bind(this)}>
                    {displayNoneCycle}일간 보지 않기
                </div>
                <div onClick={this.onClickDisplayCycle.bind(this)}>확인</div>
            </div>
        );
    }

    onClickDisplayCycle() {
        this.setState({ visible: false });
    }

    onClickDisplayNoneCycle() {
        const { item } = this.state;
        const displayNoneCycle = item?.data?.eventInfo?.displayNoneCycle ?? '1';
        this.setStorage(displayNoneCycle);
    }

    renerContent() {
        const { item } = this.state;
        const eventInfo = item?.data?.eventInfo ?? false;

        if (!eventInfo) {
            return;
        }

        return (
            <div className="event-popup-content">
                <div className="content-wrapper">
                    <a
                        href={eventInfo.linkUrl}
                        target={
                            eventInfo.linkUrl.indexOf(values.baseName) === -1
                                ? '_blank'
                                : null
                        }
                    >
                        <img src={eventInfo.desktop} alt="popImage" />
                    </a>
                </div>
            </div>
        );
    }

    render() {
        const { visible, item } = this.state;

        if (
            !visible ||
            !Object.keys(item).length ||
            !this.checkDisplayActorStatus()
        ) {
            return null;
        }

        return (
            <div id="lay-wrap" className="layer new-layer">
                <div className="layer-popup-wrap">
                    <div className="popup">
                        <div className="layer-content">
                            {this.renerContent()}
                        </div>
                        {this.renderCheckBox()}
                    </div>
                </div>
                <div className="dim"></div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventPopUp);
